import React, { useState } from "react";
import "./Footer.css";

const Footer: React.FC = () => {
  const [copiedEmail, setCopiedEmail] = useState<string | null>(null);

  const copyToClipboard = async (email: string) => {
    try {
      await navigator.clipboard.writeText(email);
      setCopiedEmail(email);
      setTimeout(() => setCopiedEmail(null), 2000);
    } catch (err) {
      console.error("Failed to copy email: ", err);
    }
  };

  const CopyIcon = ({ email }: { email: string }) => {
    const isIconCopied = copiedEmail === email;

    return (
      <button
        className="copy-button"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(email);
        }}
        aria-label={`Copy ${email} to clipboard`}
      >
        {isIconCopied ? (
          <svg
            className="copy-icon checkmark"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20,6 9,17 4,12"></polyline>
          </svg>
        ) : (
          <svg
            className="copy-icon"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        )}
      </button>
    );
  };

  return (
    <footer className="footer">
      <p>
        Feito com amor por{" "}
        <span className="author-name">
          Matheus Duque
          <span className="author-email">
            <CopyIcon email="matheusccbr@gmail.com" />
            matheusccbr@gmail.com
          </span>
        </span>
        {", "}
        <span className="author-name">
          Gustavo Marinatto
          <span className="author-email">
            <CopyIcon email="marinatto.gustavo@gmail.com" />
            marinatto.gustavo@gmail.com
          </span>
        </span>
        {", "}
        <span className="author-name">
          Eduarda Marques
          <span className="author-email">
            <CopyIcon email="duda@gmail.com" />
            duda@gmail.com
          </span>
        </span>
        {", "}
        <span className="author-name">
          Matheus Hack
          <span className="author-email">
            <CopyIcon email="matheushackbus@gmail.com" />
            matheushackbus@gmail.com
          </span>
        </span>
        {" e "}
        <span className="author-name">
          Daniel Nocito
          <span className="author-email">
            <CopyIcon email="nocito@ufrj.br" />
            nocito@ufrj.br
          </span>
        </span>
        .
      </p>
    </footer>
  );
};

export default Footer;
